import { Form, Input, Rate } from "antd";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

export const RatingModal = (props) => {
  const {
    starRatingColor,
    bookingId,
    isBookingValid,
    setBookingId,
    showRatingModal,
    handleRatingSubmit,
    setShowRatingModal,
    handleValidateBooking,
    guestInfo,
    setGuestInfo,
  } = props;
  const { t } = useTranslation();
  return (
    <Modal
      title="Rate & Review"
      show={showRatingModal}
      onOk={handleRatingSubmit}
      onCancel={() => setShowRatingModal(false)}
      footer={null}
    >
      <Form layout="vertical">
        <Form.Item
          label={<strong>Booking ID</strong>}
          style={{ margin: "24px" }}
        >
          <Input
            value={bookingId}
            onChange={(e) => setBookingId(e.target.value)}
            placeholder="Enter your booking ID to review"
          />
        </Form.Item>
        <Button
          type="primary"
          onClick={handleValidateBooking}
          block
          style={{ marginBottom: "24px", marginLeft: "24px" }}
        >
          {t("room.validate")}
        </Button>
        <Button
          type="default"
          onClick={() => setShowRatingModal(false)}
          style={{
            flex: 1,
            marginBottom: "24px",
            marginLeft: "24px",
          }}
        >
          {t("room.close")}
        </Button>
        {isBookingValid && (
          <>
            <Form.Item
              label={<strong>{t("room.guest_name")}</strong>}
              style={{ margin: "24px" }}
            >
              <Input
                placeholder="Enter your name"
                value={guestInfo.name}
                onChange={(e) =>
                  setGuestInfo((prev) => ({ ...prev, name: e.target.value }))
                }
              />
            </Form.Item>
            <Form.Item
              label={<strong>{t("room.rate_the_room")}</strong>}
              style={{ margin: "24px" }}
            >
              <Rate
                value={guestInfo.rating}
                onChange={(value) =>
                  setGuestInfo((prev) => ({ ...prev, rating: value }))
                }
                style={{
                  background: "none",
                  border: "none",
                  color: starRatingColor,
                  cursor: "pointer",
                  fontSize: "20px",
                }}
              />
            </Form.Item>
            <Form.Item
              label={<strong>{t("room.your_review")}</strong>}
              style={{ margin: "24px" }}
            >
              <Input.TextArea
                rows={3}
                placeholder="Write your review here..."
                value={guestInfo.comment}
                onChange={(e) =>
                  setGuestInfo((prev) => ({ ...prev, comment: e.target.value }))
                }
              />
            </Form.Item>
            <Button
              type="primary"
              onClick={handleRatingSubmit}
              style={{ margin: "24px" }}
              disabled={!guestInfo.rating || !guestInfo.comment}
              block
            >
              {t("room.submit_rating")}
            </Button>
          </>
        )}
      </Form>
    </Modal>
  );
};
